import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";

export const DeliveryAddress = types
  .model({
    address: types.maybeNull(types.string),
    customerId: types.maybeNull(types.string),
    id: types.maybeNull(types.string),
  })
  .actions(withSetPropAction);
export interface IDeliveryAddress extends Instance<typeof DeliveryAddress> {}
export interface IDeliveryAddressProperties
  extends SnapshotIn<typeof DeliveryAddress> {}
